import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { environment } from 'src/environments/environment';
import { GetUBSResponse } from '../../responses/ubs-health-promotion/get-ubs-response';
import { UBSDataSectionResponse } from '../../responses/ubs-health-promotion/ubs-data-section.response';

@Injectable({
  providedIn: 'root'
})
export class UBSDataSectionService extends CommonService {

  constructor(private router: Router, private httpClient: HttpClient,) {
    super();
  }

  public getUBSDataSection(idPatient: number): Observable<UBSDataSectionResponse> {
    let uri = `UBSDataSection/idPatient/${idPatient}`
    return this.httpClient.get<UBSDataSectionResponse>(environment.urlApiUbsHealthPromotion + uri, this.addHeaderHash())
      .pipe(
        catchError(this.handleError)
      )
  }
}